import {arrEquals} from "../utils/collections";
import {OnUpdated} from "./on-updated";
import {OnUnmounted} from "./on-unmounted";
import {Invoke} from "./invoke";
import {Static2} from "./static-2";
import {cs} from "./chain-services";
import {fragments} from "./fragments";

export const Effect = ({action, props=undefined, watches=undefined}) => cs(
    ["cleanup", (_, next) => Static2({next})],
    ({cleanup}) => fragments(
        Invoke({
            props,
            action: (params) => {
                cleanup.set(action(params));
            },
        }),
        OnUpdated({
            props: {watches,props},
            action: ({prevProps, getLatestProps}) => {
                if (!arrEquals(prevProps.watches, watches)) {
                    cleanup.get()?.();
                    cleanup.set(action({getLatestProps: () => getLatestProps().props}));
                }
            },
        }),
        OnUnmounted({
            action: () => {
                cleanup.get()?.();
            },
        }),
    ),
);
